module.exports = __webpack_public_path__ + "static/img/aBrightFutureForKidsTestimonial.77ebe04.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/a-bright-future-for-kids/aBrightFutureForKidsTestimonial.jpg
// module id = 47
// module chunks = 0